<template>
    <div
      class="background-image"
      :style="combinedStyle"
    >
    <slot></slot>
</div>
  </template>

  <script>
  export default {
    name: 'BackgroundImage',
    props: {
      imageUrl: {
        type: String, // 背景图片路径
        required: true, // 必须传入
      },
      customStyle: {
        type: Object, // 自定义样式
        default: () => ({}), // 默认值为空对象
      },
    },
    computed: {
      combinedStyle() {
        return {
          backgroundImage: `url(${this.imageUrl})`, // 背景图片
          backgroundSize: 'cover', // 默认样式
          backgroundPosition: 'center', // 默认样式
          ...this.customStyle, // 合并传入的样式
        };
      },
    },
  };
  </script>
